import React from 'react';
import PropTypes from 'prop-types';
import Icon from "./IconUtil.js";
import Theme from "./Theme.js";
/**
 * React class that renders a button with an on and an off state
 * @prop {string} className - css class to be applied to this component 
 * @prop {string} variant - Theme variant name to be added to the component 
 * @prop {function} onChange - function to be called when the button is clicked 
 * @prop {any} eventData - will be passed through as the data key to the onClick function 
 * @prop {boolean} value - tells the button if it is an on or off state 
 * @prop {node} on - react element to be displayed if value is true 
 * @prop {node} off - react element to be displayed if value is false 
 * @prop {string} iconOn - string of font to be displayed if value is true 
 * @prop {string} iconOff - string of font to be displayed if value is false 
 * @prop {node} children - internal component children, will be handled by react 
 **/
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class ToggleButton extends React.Component {
  static contextType = Theme.Context;
  static propTypes = {
    className: PropTypes.string,
    variant: PropTypes.string,
    onChange: PropTypes.func,
    eventData: PropTypes.any,
    value: PropTypes.bool,
    on: PropTypes.node,
    // eslint-disable-line
    off: PropTypes.node,
    // eslint-disable-line
    iconOn: PropTypes.string,
    // eslint-disable-line
    iconOff: PropTypes.string,
    // eslint-disable-line
    children: PropTypes.node
  };
  static defaultProps = {
    className: null,
    variant: null,
    onChange: null,
    eventData: null,
    value: false,
    children: null
    // iconOn : null, // dont put these in, it will screw up theme props
    // iconOff : null
    // on : null, 
    // off : null
  };

  /** 
   * (Internal) onClick of the element just adds the eventData prop to the event, and then calls the onClick prop
   */
  onClick = e => {
    const {
      value,
      onChange,
      eventData,
      stopPropagation
    } = this.props;
    e.preventDefault();
    if (stopPropagation !== false) {
      e.stopPropagation();
    }
    if (typeof onChange === 'function') {
      onChange({
        value: !value,
        data: eventData,
        sourceEvent: e
      });
    }
  };
  render() {
    const theme = this.context;
    const {
      className,
      variant,
      value = false,
      on,
      off,
      icon,
      iconOn,
      iconOff,
      iconPosition,
      imageOpts,
      imageOnOpts,
      imageOffOpts,
      iconOpts,
      iconOnOpts,
      iconOffOpts,
      children,
      onChange,
      eventData,
      domRef,
      layoutOptions,
      stopPropagation,
      type = 'button',
      'data-error': dataError,
      ...rest
    } = theme.props('ToggleButton', this.props);
    const cs = value && on ? on : !value && off ? off : children;
    const cn = theme.classes('ToggleButton', 'toggleButton', variant, className);
    const sCn = theme.subclasses('ToggleButton', 'label');
    const {
      icon: uIcon,
      iconOn: uIconOn,
      iconOff: uIconOff
    } = this.props;
    const cIcon = value ? Icon.selectIcon(uIconOn, uIcon, iconOn, icon) : Icon.selectIcon(uIconOff, uIcon, iconOff, icon);
    const cIconOpts = value ? iconOnOpts || iconOpts : iconOffOpts || iconOpts;
    const cImageOpts = value ? imageOnOpts || imageOpts : imageOffOpts || imageOpts;
    if (cIcon && cIcon !== '') {
      const fChildren = React.Children.map(cs, c => {
        return typeof c === 'string' ? /*#__PURE__*/_jsx("span", {
          className: sCn,
          children: c
        }) : c;
      });

      /* eslint-disable react/button-has-type */
      return /*#__PURE__*/_jsxs("button", {
        className: cn,
        ...rest,
        type: type,
        ref: domRef,
        "data-value": value,
        "data-error": dataError,
        onClick: this.onClick,
        children: [cIcon && iconPosition !== 'end' ? Icon.create(cIcon, cImageOpts, cIconOpts, theme) : null, fChildren, cIcon && iconPosition === 'end' ? Icon.create(cIcon, cImageOpts, cIconOpts, theme) : null]
      });
    }
    // put single string in span so ellipsis can work
    let ch = cs;
    if (ch && React.Children.count(cs) === 1) {
      ch = React.Children.map(ch, c => {
        return typeof c === 'string' ? /*#__PURE__*/_jsx("span", {
          className: sCn,
          children: c
        }) : c;
      });
    }
    return /*#__PURE__*/_jsx("button", {
      className: cn,
      ...rest,
      type: type,
      ref: domRef,
      "data-value": value,
      onClick: this.onClick,
      children: ch
    });
    /* eslint-enable react/button-has-type */
  }
}
export default ToggleButton;